module.exports = __webpack_public_path__ + "fonts/AkkLg_Pro_1.3061607.otf";